'use strict';

exports.__esModule = true;
exports.default = valueMissing;
function valueMissing(value) {
  return value == null || typeof value === 'string' && value.trim() === '';
}


//////////////////
// WEBPACK FOOTER
// ./~/revalidate/lib/internal/valueMissing.js
// module id = 259
// module chunks = 0